import React from 'react';
import { connect } from 'react-redux';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import { disconnectShop, closeDisconnectShopModal } from 'actions/onlineStore';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import styles from './DisconnectShopModal.css';

class DisconnectShopModal extends React.Component {
  render() {
    const { disconnectModal } = this.props;
    const { selectedShop, selectedOutlet, show } = disconnectModal;

    return (
      <ConfirmModal
        backdrop="static"
        dialogClassName={styles.modal}
        showModal={show}
        title={this._getModalTitle(selectedShop)}
        description={this._getModalDescription(selectedShop, selectedOutlet)}
        confirmTitle="Disconnect"
        onConfirm={this._handleConfirm}
        onHide={this._handleHide}
      />
    );
  }

  _getModalTitle = shop => {
    if (!shop) {
      return;
    }

    if (shop.channel === ONLINE_STORE_CHANNEL.FACEBOOK) {
      return 'Disconnect from Facebook and Instagram?';
    }

    return 'Disconnect from Google?';
  };

  _getModalDescription = (shop, outlet) => {
    if (!shop) {
      return;
    }

    if (shop.channel === ONLINE_STORE_CHANNEL.FACEBOOK) {
      return (
        <div>
          <p>
            Disconnect <b>{shop.additional.facebook_page_name}</b> from Facebook
            and Instagram Shop?
          </p>

          <p>
            Once you confirm, your outlet will stop connecting to your Facebook
            and Instagram Account.
          </p>
        </div>
      );
    }

    return (
      <div>
        <p>
          Disconnect <b>{outlet.name}</b> from Google?
        </p>

        <p>Once you confirm, your outlet will be disconnected from Google.</p>
      </div>
    );
  };

  _handleConfirm = () => {
    const { disconnectModal } = this.props;
    const { selectedShop, selectedOutlet } = disconnectModal;

    this.props.dispatch(disconnectShop(selectedShop, selectedOutlet));
  };

  _handleHide = () => {
    this.props.dispatch(closeDisconnectShopModal());
  };
}

function mapStateToProps(state) {
  const { disconnectModal } = state.onlineStore;

  return {
    disconnectModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisconnectShopModal);
